import max from "lodash/max";
import min from "lodash/min";
import type { SortType } from "types/output-exercise";

const MIN_PERCENTAGE_BG_COLOR = 75;

class WidgetTargetHelpers {
  /**
   * @description Method to calculate the target progress. It returns the percentage of the value in relation to the target.
   */
  static calculateTargetProgress(value: number, target: number, sortType: SortType = 1): number | null {
    if (value === 0 || target === 0) return null;
    const parsedValue = Number(value.toFixed(3));
    const parsedTarget = Number(target.toFixed(3));

    const percentage = WidgetTargetHelpers.calculatePercentageOfValue(parsedValue, parsedTarget, sortType);

    return Math.floor(percentage);
  }

  /**
   * @deprecated in favour of NumberHelpers.calculatePercentage
   */
  static calculatePercentageOfValue(value: number, best: number, sortType: 0 | 1 = 1): number {
    if (sortType === 0) {
      if (best === value) return 100;

      const v = (1 - (value - best) / value) * 100;
      if (isNaN(v)) return 0;

      return v;
    }

    const percentage = (value / best) * 100;
    if (isNaN(percentage)) return 0;

    return percentage;
  }
  static getBestValue(values: number[], sortType?: 0 | 1): number {
    if (sortType !== 0) {
      return max(values) || 0;
    }
    return min(values) || 0;
  }

  /**
   * @description Method to get the badge background color based on the target value percentage.
   * If the target value is greater than or equal to 75%, it returns the color a positive color, otherwise a neutral color.
   *
   * @important The 75% was chosen according to the project's design system.
   */
  static getGaugeColorType(percentage: number | null): "neutral" | "positive" | "positiveGradient" {
    if (percentage === null) return "neutral";
    if (percentage >= 100) return "positive";
    return percentage >= MIN_PERCENTAGE_BG_COLOR ? "positiveGradient" : "neutral";
  }
}

export default WidgetTargetHelpers;
